// Unified CRM date filter — date field picker + quick presets + custom From–To.
// Same control on Deals, Leads, Quotes and Customers.
import { CalendarRange, X } from "lucide-react";
import { DATE_RANGE_OPTIONS, normalizeDateFilter, isDateFilterActive, EMPTY_DATE_FILTER } from "../lib/dateRange";

const sel = "dark-select h-9 bg-transparent text-[12px] text-white outline-none px-1.5 [color-scheme:dark] cursor-pointer";

export default function DateRangeFilter({ value, onChange, fields = [], testid = "date-filter" }) {
  const v = normalizeDateFilter(value);
  const active = isDateFilterActive(v);
  const set = (p) => onChange({ ...v, ...p });
  const field = v.field || fields[0]?.value || "";
  return (
    <div
      data-testid={testid}
      className={`inline-flex items-center gap-0.5 h-9 pl-2 pr-1 rounded-md border transition-colors ${active ? "border-orange-400/50 bg-orange-500/10" : "border-white/10 bg-white/[0.02]"}`}
    >
      <CalendarRange className={`w-3.5 h-3.5 shrink-0 ${active ? "text-orange-300" : "text-slate-500"}`} />
      {fields.length > 1 && (
        <select value={field} onChange={(e) => set({ field: e.target.value })} className={`${sel} text-slate-300`} data-testid={`${testid}-field`} title="Which date to filter by">
          {fields.map((f) => <option key={f.value} value={f.value}>{f.label}</option>)}
        </select>
      )}
      <select value={v.preset} onChange={(e) => set({ preset: e.target.value })} className={sel} data-testid={`${testid}-preset`}>
        {DATE_RANGE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        <option value="custom">Custom range…</option>
      </select>
      {v.preset === "custom" && (
        <>
          <input type="date" value={v.from} max={v.to || undefined} onChange={(e) => set({ from: e.target.value })}
            className="h-7 px-1.5 rounded bg-slate-900/70 border border-white/10 text-[11.5px] text-white [color-scheme:dark]" data-testid={`${testid}-from`} aria-label="From date" />
          <span className="text-slate-500 text-[11px]">–</span>
          <input type="date" value={v.to} min={v.from || undefined} onChange={(e) => set({ to: e.target.value })}
            className="h-7 px-1.5 rounded bg-slate-900/70 border border-white/10 text-[11.5px] text-white [color-scheme:dark]" data-testid={`${testid}-to`} aria-label="To date" />
        </>
      )}
      {active && (
        <button type="button" onClick={() => onChange({ ...EMPTY_DATE_FILTER, field: v.field })} className="p-1 rounded text-slate-400 hover:text-white" data-testid={`${testid}-clear`} aria-label="Clear date filter">
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}
